export default __webpack_public_path__ + "static/media/corporate.5f507d59.png";